import { InputHTMLAttributes } from 'react'

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  checkboxClassName?: string
  description: string
  descriptionClassName?: string
}

const Checkbox = ({
  checkboxClassName,
  description,
  descriptionClassName,
  ...inputProps
}: CheckboxProps) => {
  const checkboxDefaultClassName = "rounded-md border-[#D0D5DD] w-5 h-5"
  const descriptionDefaultClassName = "text-text-color-mid-em"

  return (
    <div className="flex items-start space-x-3">
      <input
        type="checkbox"
        className={checkboxClassName ? checkboxClassName : checkboxDefaultClassName}
        {...inputProps}
      />
      <p
        className={descriptionClassName ? descriptionClassName : descriptionDefaultClassName}
      >
        {description}
      </p>
    </div>
  )
}

export default Checkbox